import { store } from "@betacrew/jars-flux";
import { PAGE_STATE } from "../../../constants/constants";

export const componentKey = "FORMS/FORM_STATE_PAYROLL";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setFiltersLoadingState: (state, action) => {
            state.filtersLoadingState = action.payload;
        },
        setStateList: (state, action) => {
            state.stateList = action.payload;
        },
        setFormList: (state, action) => {
            state.formList = action.payload;
        },
        setTaxYearList: (state, action) => {
            state.taxYearList = action.payload;
        },
        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },
        setFormStatus: (state, action) => {
            state.formStatus = action.payload;
        },
        setStatePayrollSubmittedFormsList: (state, action) => {
            state.statePayrollSubmittedFormsList = action.payload;
        },
        setSelectedState: (state, action) => {
            state.selectedState = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setStatePayrollSubmitGridData: (state, action) => {
            state.statePayrollSubmitGridData = action.payload;
        },
        setSelectedStatePayrollSubmitGridData: (state, action) => {
            state.selectedStatePayrollSubmitGridData = action.payload;
        },
        setPaginationState: (state, action) => {
            state.paginationState = action.payload;
        },
        setReloadSubmitGridData: (state, action) => {
            state.reloadSubmitGridData = action.payload;
        },
        setSelectedForms: (state, action) => {
            state.selectedReadyToSubmitForms = action.payload
        },
        setSubmittedFormsDetails: (state, action) => {
            state.submittedFormsDetails = action.payload;
        },
        setHighlightedStatePayrollForm: (state, action) => {
            state.highlightedStatePayrollForm = action.payload
        },
        setStatePayrollFormDetailsDrawerOpen: (state, action) => {
            state.statePayrollFormDetailsDrawerOpen = action.payload
        },
        setStatePayrollFormDetails: (state, action) => {
            state.statePayrollFormDetails = action.payload
        },
        setStatePayrollFormDetailsDrawerLoader: (state, action) => {
            state.statePayrollformDetailsDrawerLoader = action.payload;
        },
        setLoadStatePayrollFormsDataState: (state, action) => {
            state.loadStatePayrollFormsDataState = action.payload
        },
        setSubmitStatePayrollFormFees: (state, action) => {
            state.submitStatePayrollFormFees = action.payload
        },
        setDeleteStatePayrollFormsModalOpen: (state, action) => {
            state.deleteStatePayrollFormsModal = action.payload
        },
        setShouldGetSubmittedStatePayrollFormsGridData: (state, action) => {
            state.shouldGetSubmittedStatePayrollFormsGridData = action.payload;
        },
        setStatePayrollSubmitForThisPayerModal: (state, action) => {
            state.statePayrollSubmitForThisPayerOpen = action.payload
        },
        setShowPaymentNotAllowedPopup: (state, action) => {
            state.showPaymentNotAllowedPopup = action.payload;
        },
        setUrlFormIdParam: (state, action) => {
            state.urlFormIdParam = action.payload;
        },
        setUrlPayerIdParam: (state, action) => {
            state.urlPayerIdParam = action.payload;
        },
        setSubmitForThisPayerReviewedCheckboxModal: (state, action) => {
            state.submitForThisPayerReviewedCheckboxModal = action.payload;
        },
        setSubmitForThisPayerReviewedCheckbox: (state, action) => {
            state.submitForThisPayerReviewedCheckbox = action.payload;
        },
        setAssignStatePayrollFormsToReviewersModal: (state, action) => {
            state.assignStatePayrollFormsToReviewersModal = action.payload;
        },
        setIsFormGridLoading: (state, action)=>{
            state.isFormGridLoading = action.payload;
        }
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
        filtersLoadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
        stateList: [],
        selectedState: { label: "", value: "" },

        formList: [],
        selectedForm: { label: "", value: "" },

        taxYearList: [],
        selectedTaxYear: { label: "", value: "" },

        payerList: [],
        selectedPayer: { label: "", value: "" },
        formStatus: { label: "", value: "" },
        statePayrollSubmittedFormsList: [],


        statePayrollSubmitGridData: [],
        selectedStatePayrollSubmitGridData: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            SearchByTIN: "",
            SearchByName: "",
            IsDesc: true,
            Skip: 0,
            total: 10,
        },

        reloadSubmitGridData: false,
        selectedReadyToSubmitForms: [],
        submittedFormsDetails: { RecordCount: {} },
        highlightedStatePayrollForm: {},
        statePayrollFormDetailsDrawerOpen: false,
        statePayrollFormDetails: {},
        statePayrollformDetailsDrawerLoader: { state: PAGE_STATE.PRE_LOADING, message: "" },
        loadStatePayrollFormsDataState: { state: false, type: "" },
        submitStatePayrollFormFees: {},
        deleteStatePayrollFormsModal: {
            state: false,
            fromDrawer: false,
        },
        shouldGetSubmittedStatePayrollFormsGridData: {
            gridData: false,
            updatePagination: false,
        },
        statePayrollSubmitForThisPayerOpen: false,
        showPaymentNotAllowedPopup: false,
        urlFormIdParam: null,
        urlPayerIdParam: null,
        submitForThisPayerReviewedCheckboxModal: false,
        submitForThisPayerReviewedCheckbox: false,
        assignStatePayrollFormsToReviewersModal: false,
        isFormGridLoading: false
    }
})

export const {
    setLoadingState,
    setFiltersLoadingState,
    setStateList,
    setSelectedState,
    setFormList,
    setSelectedForm,
    setTaxYearList,
    setSelectedTaxYear,
    setPayerList,
    setSelectedPayer,
    setFormStatus,
    setStatePayrollSubmittedFormsList,
    setStatePayrollSubmitGridData,
    setSelectedStatePayrollSubmitGridData,
    setPaginationState,
    setReloadSubmitGridData,
    setSelectedForms,
    setSubmittedFormsDetails,
    setHighlightedStatePayrollForm,
    setStatePayrollFormDetailsDrawerOpen,
    setStatePayrollFormDetails,
    setStatePayrollFormDetailsDrawerLoader,
    setLoadStatePayrollFormsDataState,
    setSubmitStatePayrollFormFees,
    setDeleteStatePayrollFormsModalOpen,
    setShouldGetSubmittedStatePayrollFormsGridData,
    setStatePayrollSubmitForThisPayerModal,
    setShowPaymentNotAllowedPopup,
    setUrlFormIdParam,
    setUrlPayerIdParam,
    setSubmitForThisPayerReviewedCheckboxModal,
    setSubmitForThisPayerReviewedCheckbox,
    setAssignStatePayrollFormsToReviewersModal
} = actions
